import { getTransferDataV2 } from '@/apis/wallet';

export const ton_buildTokenTransferTransaction = async (
  fromAddress: string,
  toAddress: string,
  toTokenAddress: string,
  contract: string,
  amount: number,
  publicKey: string,
  symbol: string
) => {
  try {
    const apiRes: any = await getTransferDataV2.fetcher({
      chain: 'ton',
      from: fromAddress,
      to: toTokenAddress,
      amount: amount,
      symbol,
      contract: contract,
      publicKey: publicKey,
      memo: toAddress,
    });
    return apiRes;
  } catch (error) {
    return '';
  }
};
